import axios from 'axios';
import {
  AnnotationDefinition,
  AnnotationDefinitionFilter,
  AnnotationsManagerSortBy,
  AnnotationType,
} from '../../../models/annotation.types';

import EnvWindow from '../../../utils/env';
import { addParam, addParamsList } from '../../../utils/servicesHelper';

const defaultFilter = {
  annotationType: [],
  repetitive: [],
  name: '',
  description: '',
  active: [true],
};

export async function getAnnotationDefinitions(
  filter: AnnotationDefinitionFilter = defaultFilter,
  sortByColumnId: AnnotationsManagerSortBy = 'annotationType',
  isDescending = true,
  signal?: AbortSignal,
): Promise<AnnotationDefinition[]> {

  let params = '';
  params += addParam('name', filter.name ? filter.name : '');
  params += addParam('description', filter.description ? filter.description : '');

  const filterByActive = filter.active.includes(true);
  const filterByInActive = filter.active.includes(false);
  params += addParam(
    'active',
    !filter.active.length || (filterByActive && filterByInActive) ? '' : filterByActive ? 'true' : 'false',
  );

  const filterByStatic= filter.annotationType.includes(AnnotationType.static);
  const filterByDynamic= filter.annotationType.includes(AnnotationType.dynamic);
  params += addParam(
    'annotationType',
    !filter.annotationType.length || (filterByStatic && filterByDynamic) ? '' : filterByStatic ? AnnotationType.static : AnnotationType.dynamic,
  );

  const filterByRepetitive = filter.repetitive.includes(true);
  const filterByNonRepetitive = filter.repetitive.includes(false);

  params += addParam(
    'repetitive',
    !filter.repetitive.length || (filterByRepetitive && filterByNonRepetitive)
      ? ''
      : filterByRepetitive
        ? 'true'
        : 'false',
  );
  params += addParam('sortBy', sortByColumnId);
  params += addParam('descending', isDescending ? 'true' : 'false');

  const response = await axios.get(`${EnvWindow.REACT_APP_ADMIN__ANNOTATIONS_API_URL}?${params}`, {
    signal: signal ?? undefined,
  });
  return response.data;
}

export enum AnnotationDefAddResult {
  IconAlreadyExists,
  NameAlreadyExists,
  Success,
  Fail
}

export async function createAnnotationDefinition(name: string, description: string, svg: string, annotationType: AnnotationType, repetitive: boolean): Promise<AnnotationDefAddResult> {
  const body = { name: name, description: description, svg: svg, annotationType: annotationType, repetitive: repetitive };
  const response = await axios.post(`${EnvWindow.REACT_APP_ADMIN__ANNOTATIONS_API_URL}`, body)
  return response.data;
}

export async function updateAnnotationDefinition(annotationDefinition: AnnotationDefinition): Promise<AnnotationDefAddResult> {
  const body = { id: annotationDefinition.id, name: annotationDefinition.name, description: annotationDefinition.description, svg: annotationDefinition.svg, annotationType: annotationDefinition.annotationType, repetitive: annotationDefinition.repetitive }
  const response = await axios.put(`${EnvWindow.REACT_APP_ADMIN__ANNOTATIONS_API_URL}`, body)
  return response.data;
}

export async function changeAnnotationDefinitionActiveness(annotationDefinitionId: string, activeness: boolean): Promise<boolean> {
  const response = await axios.patch(`${EnvWindow.REACT_APP_ADMIN__ANNOTATIONS_API_URL}/${annotationDefinitionId}/active/${activeness}`);
  return response.data;
}
